import { render, staticRenderFns } from "./conDashboard.vue?vue&type=template&id=4c1dc973&scoped=true"
import script from "./conDashboard.vue?vue&type=script&lang=js"
export * from "./conDashboard.vue?vue&type=script&lang=js"
import style0 from "./conDashboard.vue?vue&type=style&index=0&id=4c1dc973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1dc973",
  null
  
)

export default component.exports